import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './kpi-row.types';
import * as constants from './kpi-row.constants';

export const kpiRowReducer = generateResourceReducer<types.IKpiRow>({
  STORE: constants.STORE_KPI_ROW,
  CLEAR: constants.CLEAR_KPI_ROW,
});
